import React, {Component} from 'react';
import SearchForm from "../../components/SearchForm";
import AcceptedTenderRequest from "./AcceptedTenderRequest";
import BackEnd from "../../../../backend/BackEnd";
import Pager from "../../../../controls/Pager";
import {numericForms} from "../../../../utils/formatters";

class AcceptedTenderRequestList extends Component {
    static propTypes = {};
    static defaultProps = {
        pageSize: 10
    };
    state = {
        isLoading: false,
        items: [],
        totalCount: 0,
        pageIndex: 0
    };
    searchCriteria = {};
    searchAccepted = new BackEnd.TenderRequestSearch.SearchAccepted(this);

    async componentDidMount() {
        await this.search();
    }

    render() {
        const loadingSpinner = <div className="text-center m-t-2">
            <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
        </div>;

        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-arrow-graph-up-right"/>Заказы /
                                </span> Мои торги
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-4 pull-xxl-right m-b-2">
                        <SearchForm onChange={criteria => this.search(criteria)}/>
                    </div>
                    <div className="col-xxl-8">
                        <div className="panel">
                            <div className="panel-body p-y-1">
                                <div className="row">
                                    <div className="col-md-6 p-t-1">
                                        {
                                            !this.state.isLoading &&
                                            `Всего найдено ${numericForms(this.state.totalCount, 'заказ', 'заказа', 'заказов')}`
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <div className="pull-right">
                                            <Pager className="p-a-0 m-a-0" size="sm"
                                                   pageSize={this.props.pageSize}
                                                   pageIndex={this.state.pageIndex}
                                                   totalCount={this.state.totalCount}
                                                   onChange={pageIndex => this.updatePageIndex(pageIndex)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.isLoading
                                ? loadingSpinner
                                : this.state.items.map(tender =>
                                    <AcceptedTenderRequest key={tender.tenderRequestId} data={tender}
                                                           onRemove={() => this.search()}/>)
                        }
                    </div>
                </div>
            </div>
        );
    }

    async updatePageIndex(pageIndex) {
        this.setState({pageIndex});
        await this.search(this.searchCriteria, pageIndex);
    }

    async search(criteria = this.searchCriteria, pageIndex = this.state.pageIndex) {
        this.searchCriteria = criteria;

        let result = await this.searchAccepted.call({
            dto: {
                ...criteria,
                paging: {
                    pageIndex: pageIndex,
                    pageSize: this.props.pageSize
                }
            }
        });

        this.setState({...result});
    }
}

export default AcceptedTenderRequestList;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/TenderRequests/Accepted/AcceptedTenderRequestList.js